'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _webfontloader = require('webfontloader');

var _webfontloader2 = _interopRequireDefault(_webfontloader);

var _statuses = require('./statuses');

var _statuses2 = _interopRequireDefault(_statuses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var noop = function noop() {};

var WebfontLoader = function (_Component) {
  _inherits(WebfontLoader, _Component);

  function WebfontLoader() {
    _classCallCheck(this, WebfontLoader);

    return _possibleConstructorReturn(this, (WebfontLoader.__proto__ || Object.getPrototypeOf(WebfontLoader)).apply(this, arguments));
  }

  _createClass(WebfontLoader, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props;
      var config = _props.config;
      var onStatus = _props.onStatus;
      var onFontStatus = _props.onFontStatus;

      _webfontloader2.default.load(_extends({}, config, {
        loading: function loading() {
          return onStatus(_statuses2.default.loading);
        },
        active: function active() {
          return onStatus(_statuses2.default.active);
        },
        inactive: function inactive() {
          return onStatus(_statuses2.default.inactive);
        },
        fontloading: function fontloading(font, variation) {
          return onFontStatus(font, variation, _statuses2.default.loading);
        },
        fontactive: function fontactive(font, variation) {
          return onFontStatus(font, variation, _statuses2.default.active);
        },
        fontinactive: function fontinactive(font, variation) {
          return onFontStatus(font, variation, _statuses2.default.inactive);
        }
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return children;
    }
  }]);

  return WebfontLoader;
}(_react.Component);

WebfontLoader.propTypes = {
  config: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.element.isRequired,
  onStatus: _propTypes2.default.func.isRequired,
  onFontStatus: _propTypes2.default.func.isRequired
};

WebfontLoader.defaultProps = {
  onStatus: noop,
  onFontStatus: noop
};

exports.default = WebfontLoader;


//////////////////
// WEBPACK FOOTER
// ./~/@dr-kobros/react-webfont-loader/lib/index.js
// module id = 537
// module chunks = 0